import { render, staticRenderFns } from "./PaperIcon.vue?vue&type=template&id=cd7a0f32"
import script from "./PaperIcon.vue?vue&type=script&lang=js"
export * from "./PaperIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports